
<agpr-take-over-panel
    [id]="'manageMailingListsDialog'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="950"
    [maxPanelWidth]="1200"
    header="Common.mailingLists.manageDialog.heading"
>
    <div class='agpr-manageMailingListsDialog-content'>
        <div
            aria-labelledby="manageMailingListsDialog.lhp.heading"
            class="agpr-column"
            role="group"
        >
            <div class="agpr-column-toolbar">
                <div
                    [id]="'manageMailingListsDialog_lhp_heading'"
                    class="agpr-column-heading"
                >
                    <span>{{ 'Common.mailingLists.manageDialog.mailingLists.heading' | localize }}</span>
                    <agpr-button
                        [id]="'manageMailingListsDialog_mailingLists_createMailing'"
                        class="agpr-column-heading-button"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-square-plus"
                        tooltip="Common.mailingLists.manageDialog.mailingLists.create"
                        (click)="createMailingList()"
                    ></agpr-button>
                </div>
                <agpr-text-input
                    [id]="'manageMailingListsDialog_mailingLists_search'"
                    ariaLabel="Common.mailingLists.manageDialog.mailingLists.search"
                    icon="fa-regular fa-duotone fa-magnifying-glass"
                    autocomplete="off"
                    type="search"
                    [(ngModel)]="mailingListsSearch"
                    (ngModelChange)="filterMailingLists()"
                    placeholder="Common.mailingLists.manageDialog.mailingLists.search"
                ></agpr-text-input>
            </div>
            <agpr-scroll-panel>
                <div
                    class="agpr-column-content"
                >
                    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                    <ul
                        id="mailingLists"
                        agprListKeyboardNavigation
                        [focusOnChild]="true"
                        [list]="filteredMailingLists"
                    >
                        <li
                            *ngFor="let mailingList of filteredMailingLists; let i = index"
                            [id]="'manageMailingListsDialog_mailingLists_list_' + i"
                            class="agpr-mailingList"
                            [class.agpr-mailingList--selected]="mailingList === selectedMailingList"
                            (keydown)="selectMailingList(mailingList, $event)"
                            (click)="selectMailingList(mailingList)"
                        >
                            <span
                                class="agpr-mailingList-activeBar"
                                [ngClass]="{'agpr-mailingList-activeBar--show': mailingList === selectedMailingList}"
                            ></span>
                            <div
                                tabindex="-1"
                                class="agpr-mailingList-label"
                                [attr.aria-labelledby]="'manageMailingListsDialog.mailingLists.list-' + i + '.label'"
                            >
                                <span aria-hidden="true" class="agpr-mailingList-name">
                                    {{ mailingList.name }}
                                </span>
                                <span  aria-hidden="true" class="agpr-mailingList-count">
                                    {{ mailingList.recipientIds.length }}
                                </span>
                            </div>
                            <span
                                [id]="'manageMailingListsDialog_mailingLists_list_' + i + '_label'"
                                class="u-srOnly"
                            >
                                {{ 'Common.mailingLists.manageDialog.recipientsInList.listItemAriaLabel' | localize: {listName: mailingList.name, count: mailingList.recipientIds.length} }}
                            </span>
                            <div class="agpr-mailingList-actions">
                                <agpr-button
                                    [id]="'manageMailingListsDialog_mailingLists_list_' + i + '_edit'"
                                    class="agpr-mailingList-action"
                                    [style]="buttonTypes.icon"
                                    icon="fa-regular fa-duotone fa-pen"
                                    tooltip="Common.mailingLists.manageDialog.contextIcon.edit"
                                    tooltipPosition="top"
                                    (click)="editMailingList(mailingList)"
                                ></agpr-button>
                                <agpr-button
                                    [id]="'manageMailingListsDialog_mailingLists_list_' + i + '_delete'"
                                    class="agpr-mailingList-action"
                                    [style]="buttonTypes.icon"
                                    icon="fa-regular fa-duotone fa-trash-can"
                                    tooltip="Common.mailingLists.manageDialog.contextIcon.delete"
                                    tooltipPosition="top"
                                    (click)="deleteMailingList(mailingList)"
                                ></agpr-button>
                            </div>
                        </li>
                    </ul>
                    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                    <div
                        *ngIf="!mailingLists"
                        class="agpr-column-loading"
                        [agprLoading]="true"
                        overlayStyleClass="agpr-column-loadingOverlay"
                    ></div>
                </div>
            </agpr-scroll-panel>
            <div class="agpr-column-footer">
                <span class="agpr-column-footer-itemCount">
                    <span>
                        <span class="agpr-column-footer-itemCount--total">{{ filteredMailingLists?.length }}</span>
                        {{ 'Common.mailingLists.manageDialog.mailingLists.total' | localize }}
                    </span>
                </span>
            </div>
        </div>
        <div
            class="agpr-column agpr-column--center"
            aria-labelledby="manageMailingListsDialog.center.heading"
            role="group"
        >
            <div class="agpr-column-toolbar">
                <div
                    id="manageMailingListsDialog.center.heading"
                    class="agpr-column-heading"
                >
                    <span>{{ 'Common.mailingLists.manageDialog.recipientsInList.heading' | localize }}</span>
                    <agpr-button
                        [id]="'manageMailingListsDialog_mailingLists_createRecipient'"
                        class="agpr-column-heading-button"
                        [style]="buttonTypes.icon"
                        icon="fa-duotone fa-regular fa-file-export"
                        tooltip="Common.mailingLists.manageDialog.mailingLists.export"
                        (click)="exportMailingList()"
                    ></agpr-button>
                </div>
                <agpr-text-input
                    [id]="'manageMailingListsDialog_recipientsInList_search'"
                    ariaLabel="Common.mailingLists.manageDialog.recipientsInList.search"
                    icon="fa-regular fa-duotone fa-magnifying-glass"
                    autocomplete="off"
                    type="search"
                    [(ngModel)]="recipientsInListSearch"
                    (ngModelChange)="filterRecipientsInList()"
                    placeholder="Common.mailingLists.manageDialog.recipientsInList.search"
                ></agpr-text-input>
            </div>
            @if (filteredRecipientsInList.length) {
                <div
                    class="agpr-column-toggleButton"
                >
                    <agpr-button
                        [id]="'manageMailingListsDialog_recipientsInList_toggleButton'"
                        [style]="buttonTypes.textToggle"
                        [label]="selectedInListIds.length === 0 ? 'selectAll' : 'selectNone'"
                        (click)="selectedInListIds.length === 0 ? selectAllInList() : unselectAllInList()"
                    ></agpr-button>
                </div>
            }
            <agpr-scroll-panel>
                <div class="agpr-column-content">
                    <ul
                        id="mailingListrecipients"
                        agprListKeyboardNavigation
                        [focusOnChild]="true"
                        [list]="filteredRecipientsInList"
                    >
                        <li
                            *ngFor="let recipient of filteredRecipientsInList; let i = index"
                            [id]="'manageMailingListsDialog_recipientsInList_recipient_' + i"
                            class="agpr-recipient agpr-contextMenu-parent"
                        >
                            <agpr-checkbox
                                [id]="'manageMailingListsDialog_recipientsInList_recipient_' + i + '_select'"
                                [hiddenLabel]="recipient.name"
                                [value]="recipient.id"
                                [(ngModel)]="selectedInListIds"
                            ></agpr-checkbox>
                            <div
                                [id]="'manageMailingListsDialog_recipientsInList_recipient_' + i + '_label'"
                                class="agpr-recipient-container"
                            >
                                @if (recipient.name) {
                                    <span class="agpr-recipient-name">
                                        {{ recipient.name }}
                                    </span>
                                }
                                @if (recipient.email) {
                                    <span class="agpr-recipient-email">
                                        {{ recipient.email }}
                                    </span>
                                }
                            </div>
                            <div class="agpr-contextMenu top right">
                                <agpr-button
                                    [id]="'manageMailingListsDialog_recipientsInList_recipient_' + i + '_delete'"
                                    class="agpr-recipient-remove"
                                    [ngClass]="{
                                        'agpr-recipient-remove--noName': !recipient.name
                                    }"
                                    icon="fa-duotone fa-regular fa-square-xmark"
                                    tooltip="Core.button.remove"
                                    [ariaDescribedBy]="'manageMailingListsDialog.recipientsInList.recipient-' + i + '.label'"
                                    [style]="buttonTypes.contextMenu"
                                    (click)="removeRecipientFromList(recipient)"
                                ></agpr-button>
                            </div>
                        </li>
                    </ul>
                    <div
                        *ngIf="recipientsInListRequest"
                        class="agpr-column-loading"
                        [agprLoading]="true"
                        overlayStyleClass="agpr-column-loadingOverlay"
                    ></div>
                </div>
            </agpr-scroll-panel>
            <div class="agpr-column-footer">
                <div class="agpr-column-footer-itemCount">
                    <span>
                        <span class="agpr-column-footer-itemCount--selected">{{ selectedInListIds.length || "0"}}</span>
                        <span>
                            {{ 'Paginator.of' | localize }}
                        </span>
                        <span class="agpr-column-footer-itemCount--total">{{ filteredRecipientsInList?.length }}</span>
                        <span>
                            {{ 'Common.mailingLists.manageDialog.recipientsInList.total' | localize }}
                        </span>
                    </span>
                    <agpr-button
                        [id]="'manageMailingListsDialog_removeFromList'"
                        icon="fa-regular fa-duotone fa-square-xmark"
                        [tooltip]="'Discover.targeting.actions.removeFromList.button'"
                        tooltipPosition="top"
                        [style]="buttonTypes.contextMenu"
                        [disabled]="!selectedInListIds.length"
                        (click)="removeSelectedFromList()"
                    ></agpr-button>
                </div>
            </div>
        </div>
        <div
            aria-labelledby="manageMailingListsDialog.rhp.heading"
            class="agpr-column"
            role="group"
        >
            <div class="agpr-column-toolbar">
                <div
                    [id]="'manageMailingListsDialog_rhp_heading'"
                    class="agpr-column-heading"
                >
                    <span>{{ 'Common.mailingLists.manageDialog.allRecipients.heading' | localize }}</span>
                    <div class="agpr-column-heading-buttons">
                        <agpr-button
                            [id]="'manageMailingListsDialog_allRecipients_create'"
                            class="agpr-column-heading-button"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="Common.mailingLists.manageDialog.allRecipients.create"
                            (click)="createRecipient()"
                        ></agpr-button>
                        <agpr-button
                            [id]="'manageMailingListsDialog_allRecipients_import'"
                            class="agpr-column-heading-button"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-arrow-down-to-bracket"
                            tooltip="Common.mailingLists.manageDialog.allRecipients.import"
                            (click)="importRecipients()"
                        ></agpr-button>
                    </div>
                </div>
                <agpr-text-input
                    [id]="'manageMailingListsDialog_allRecipients_search'"
                    ariaLabel="Common.mailingLists.manageDialog.allRecipients.search"
                    icon="fa-regular fa-duotone fa-magnifying-glass"
                    autocomplete="off"
                    type="search"
                    [(ngModel)]="allRecipientsSearch"
                    (ngModelChange)="filterAllRecipients()"
                    placeholder="Common.mailingLists.manageDialog.allRecipients.search"
                ></agpr-text-input>
            </div>
            @if (allRecipientsTotal) {
                <div
                    class="agpr-column-toggleButton"
                >
                    <agpr-button
                        [id]="'manageMailingListsDialog_allRecipients_toggleButton'"
                        [style]="buttonTypes.textToggle"
                        [label]="selectedRecipientIds.length === 0 ? 'selectAll' : 'selectNone'"
                        (click)="selectedRecipientIds.length === 0 ? selectAll() : unselectAll()"
                    ></agpr-button>
                </div>
            }
            <agpr-scroll-panel (scrolledToBottom)="getMoreAllRecipients()">
                <div class="agpr-column-content">
                    <ul
                        id="allRecipients"
                        agprListKeyboardNavigation
                        [focusOnChild]="true"
                        [list]="allRecipients"
                    >
                        <li
                            *ngFor="let recipient of allRecipients; let i = index"
                            [id]="'manageMailingListsDialog_allRecipients_recipient_' + i"
                            class="agpr-recipient agpr-contextMenu-parent"
                            [class.agpr-recipient--selected]="selectedMailingList && selectedMailingList.recipientIds | includes:recipient.id"
                            [attr.aria-labelledby]="'manageMailingListsDialog.allRecipients.recipient-' + i + '.label'"
                        >
                            <agpr-checkbox
                                [id]="'manageMailingListsDialog_allRecipients_recipient_' + i + '_inSelectedList'"
                                [hiddenLabel]="recipient.name"
                                [value]="recipient.id"
                                [(ngModel)]="selectedRecipientIds"
                                (ngModelChange)="onRecipientSelectionChange()"
                            ></agpr-checkbox>
                            <div
                                [id]="'manageMailingListsDialog_allRecipients_recipient_' + i + '_label'"
                                class="agpr-recipient-container"
                            >
                                @if (recipient.name) {
                                    <span class="agpr-recipient-name">
                                        {{ recipient.name }}
                                    </span>
                                }
                                @if (recipient.email) {
                                    <span class="agpr-recipient-email">
                                        {{ recipient.email }}
                                    </span>
                                }
                            </div>
                            <div class="agpr-contextMenu top right">
                                <agpr-button
                                    [id]="'manageMailingListsDialog_allRecipients_recipient_' + i + '_edit'"
                                    class="agpr-recipient-action"
                                    icon="fa-regular fa-duotone fa-pen"
                                    tooltip="Common.mailingLists.manageDialog.contextIcon.edit"
                                    tooltipPosition="top"
                                    (click)="editRecipient(recipient)"
                                    [style]="buttonTypes.contextMenu"
                                ></agpr-button>
                                <agpr-button
                                    *ngIf="selectedMailingList"
                                    [id]="'manageMailingListsDialog_allRecipients_recipient_' + i + '_add'"
                                    class="agpr-recipient-action"
                                    icon="fa-regular fa-duotone fa-user-plus"
                                    tooltip="Common.mailingLists.manageDialog.contextIcon.addButton"
                                    tooltipPosition="top"
                                    (click)="addRecipientToSelectedList(recipient)"
                                    [style]="buttonTypes.contextMenu"
                                    [disabled]="recipientIdsInList.has(recipient.id)"
                                ></agpr-button>
                            </div>
                        </li>
                    </ul>
                    <div
                        *ngIf="allRecipientsRequest"
                        class="agpr-column-loading"
                        [agprLoading]="true"
                        overlayStyleClass="agpr-column-loadingOverlay"
                    ></div>
                </div>
            </agpr-scroll-panel>
            <div class="agpr-column-footer">
                <div class="agpr-column-footer-itemCount">
                    <span>
                        <span class="agpr-column-footer-itemCount--selected">{{ selectedRecipientIds.length || "0"}}</span>
                        <span>
                            {{ 'Paginator.of' | localize }}
                        </span>
                        <span class="agpr-column-footer-itemCount--total">{{ allRecipientsTotal }}</span>
                        <span>
                            {{ 'Common.mailingLists.manageDialog.recipientsInList.total' | localize }}
                        </span>
                    </span>
                    <div class="agpr-column-footer--allRecipients">
                        <agpr-button
                            [id]="'manageMailingListsDialog_allRecipients_add'"
                            [style]="buttonTypes.contextMenu"
                            [icon]="'fa-regular fa-duotone fa-user-plus'"
                            tooltip="Common.mailingLists.manageDialog.contextIcon.addButton"
                            tooltipPosition="top"
                            (click)="addSelectedToList()"
                            [disabled]="isAllSelectedInList"
                        ></agpr-button>
                        <agpr-button
                            [id]="'manageMailingListsDialog_allRecipients_delete'"
                            [style]="buttonTypes.contextMenu"
                            [icon]="'fa-regular fa-duotone fa-trash-can'"
                            tooltip="Core.button.delete"
                            tooltipPosition="top"
                            (click)="deleteRecipients()"
                            [disabled]="!selectedRecipientIds.length"
                        ></agpr-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="'manageMailingListsDialog_done'"
            label="done"
            [style]="buttonTypes.primary"
            (click)="hideSlideOverlay = true"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
